import {HttpClient} from "../../service/httpClient/HttpClient";

export class NewsService {
    constructor() {
        this.httpCleint = new HttpClient()
    }


    getNews(page, size) {
        return new Promise((resolve, reject) => {
            this.httpCleint.get(
                `site-news`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    getNewsDetail(newsId) {
        return new Promise((resolve, reject) => {
            this.httpCleint.get(
                `site-news/${newsId}`
            ).then(resolve).catch(reject)
        })
    }

    addNewNews(photoId,title, authorInformation, description, shortDescription) {
        return new Promise((resolve, reject) => {
            this.httpCleint.post(
                `site-news`,
                {
                    "thumbnailId": photoId,
                    "title": title,
                    "authorInformation": authorInformation,
                    "contents": description,
                    "shortDescription": shortDescription,
                    "enabled": true,
                }
            ).then(resolve).catch(reject)
        })
    }

    deleteNews(newsId) {
        return new Promise((resolve, reject) => {
            this.httpCleint.delete(
                `site-news/${newsId}`,
            ).then(resolve).catch(reject)
        })
    }

    updateNews(newsId, photoId, title, authorInformation, description, shortDescription, enabled) {
            return new Promise((resolve, reject) => {
                this.httpCleint.put(
                    `site-news/${newsId}`,
                    {
                        "thumbnailId": photoId,
                        "title": title,
                        "authorInformation": authorInformation,
                        "contents": description,
                        "shortDescription": shortDescription,
                        "enabled": true,
                    }
                ).then(resolve).catch(reject)
            })
    }
}